import React from 'react'
import { FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';


const FreeListing_property = () => {

    const navigate = useNavigate()

    const list_property = () => {
        navigate("/list-Property")
    }
    return (
        <div className="w-full md:w-80 sm:w-full mt-24 md:mt-24  bg-green-100 shadow-md md:mx-8">
            <div className='text-center mt-4'>
                <h1 className='text-3xl mx-8'>List your Property<br />
                    <span className='text-red-700 font-bold'>free</span> on <br></br><span className='text-[#54BD95] font-bold'>Placezio Estate</span>
                </h1>
            </div>

            <div className='mt-8 text-center'>
                <button className='bg-[#54BD95] w-52 text-white p-2 rounded-lg ' onClick={list_property}>Post property</button>
            </div>



            <div className='mt-8 px-4'>
                <h1 className='text-3xl text-center'>What's your Benefit</h1>
                <div className='mt-6'>
                    <div className="flex items-center space-x-3">
                        <FaCheckCircle className="text-[#54BD95]" size={20} />
                        <p className='my-2 text-lg'>Faster Deals</p>
                    </div>
                    <div className="flex items-center space-x-3">
                        <FaCheckCircle className="text-[#54BD95]" size={20} />
                        <p className='my-2 text-lg'>Cost-Free Registration</p>
                    </div>
                    <div className="flex items-center space-x-3">
                        <FaCheckCircle className="text-[#54BD95]" size={20} />
                        <p className='my-2 text-lg'>24/7 Online Availability</p>
                    </div>
                    <div className="flex items-center space-x-3">
                        <FaCheckCircle className="text-[#54BD95]" size={20} />
                        <p className='my-2 text-lg'>Professional Presentation</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FreeListing_property
